import type { HapticPattern } from "./types";

/**
 * Named haptic patterns for slot game events.
 *
 * Intensity drives perceived strength:
 *   - Android: PWM duty cycle (on/off ratio within 20ms windows)
 *   - iOS Safari 17.4+: click frequency via <input switch> toggle
 *
 * Keep individual vibration durations under 500ms for cross-device predictability.
 */
export const HapticPatterns = {

  soft: [
    { duration: 15, intensity: 0.4 },
  ],

  medium: [
    { duration: 30, intensity: 0.7 },
  ],

  hard: [
    { duration: 50, intensity: 1.0 },
  ],

  success: [
    { duration: 30, intensity: 0.6 },
    { delay: 80, duration: 40, intensity: 1.0 },
  ],

  failure: [
    { duration: 40, intensity: 1.0 },
    { delay: 30, duration: 30, intensity: 0.8 },
    { delay: 30, duration: 40, intensity: 1.0 },
  ],

} as const satisfies Record<string, HapticPattern>;

export type HapticPatternName = keyof typeof HapticPatterns;
